const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:3000';

/**
 * Saves an image to the device.
 *
 * Mobile browsers (Android especially, and in-app browsers like WhatsApp's) ignore the
 * `download` attribute on cross-origin links and can't save blob: URLs, so they just open
 * the image in a new tab. Cross-origin images therefore go through the engine's
 * /public/asset-download endpoint, which re-serves them as an attachment; same-origin
 * images (bundled assets) can be linked directly.
 *
 * Call it straight from the click handler: browsers only allow the download while
 * handling the tap.
 */
export function downloadImage(url, filename) {
  if (!url) return;
  const name = String(filename || 'image').replace(/[^\w.-]+/g, '-');
  let sameOrigin = false;
  try {
    sameOrigin = new URL(url, window.location.href).origin === window.location.origin;
  } catch {
    /* not a valid URL — leave it to the endpoint */
  }
  const href = sameOrigin
    ? url
    : `${API_BASE}/public/asset-download?url=${encodeURIComponent(url)}&filename=${encodeURIComponent(name)}`;

  const a = document.createElement('a');
  a.href = href;
  a.download = name;
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
